import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "Az\u0259rbaycanca",
  code: "az",
  messages: {
    inputMenu: {
      noMatch: "Uy\u011Fun m\u0259lumat tap\u0131lmad\u0131",
      noData: "M\u0259lumat yoxdur",
      create: '"{label}" yarat'
    },
    calendar: {
      prevYear: "\u018Fvv\u0259lki il",
      nextYear: "N\xF6vb\u0259ti il",
      prevMonth: "\u018Fvv\u0259lki ay",
      nextMonth: "N\xF6vb\u0259ti ay"
    },
    inputNumber: {
      increment: "Art\u0131r",
      decrement: "Azalt"
    },
    commandPalette: {
      placeholder: "\u018Fmr daxil edin v\u0259 ya axtar\u0131n...",
      noMatch: "Uy\u011Fun m\u0259lumat tap\u0131lmad\u0131",
      noData: "M\u0259lumat yoxdur",
      close: "Ba\u011Fla"
    },
    selectMenu: {
      noMatch: "Uy\u011Fun m\u0259lumat tap\u0131lmad\u0131",
      noData: "M\u0259lumat yoxdur",
      create: '"{label}" yarat',
      search: "Axtar..."
    },
    toast: {
      close: "Ba\u011Fla"
    },
    carousel: {
      prev: "\u018Fvv\u0259lki",
      next: "N\xF6vb\u0259ti",
      goto: "Slayd {slide} ke\xE7"
    },
    modal: {
      close: "Ba\u011Fla"
    },
    slideover: {
      close: "Ba\u011Fla"
    },
    alert: {
      close: "Ba\u011Fla"
    },
    table: {
      noData: "M\u0259lumat yoxdur"
    }
  }
});
